import { connect } from "react-redux";
import BagLinks from "./BagLinks";
import { getDefaultStoreUrl } from "../../../../state/modules/regionalStore";

const mapStateToProps = state => ({
  defaultStoreUrl: getDefaultStoreUrl(state)
});

export default connect(mapStateToProps)(BagLinks);



// WEBPACK FOOTER //
// ./template/components/MiniBag/Footer/BagLinks/index.js